import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { appUserService } from '../../services/appUserService';

// Thunks for Async Actions
export const fetchAppUsers = createAsyncThunk(
  'appUser/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await appUserService.getList();
      if (response.status) return response.data;
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAppUserById = createAsyncThunk(
  'appUser/fetchById',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await appUserService.getById(userId);
      if (response.status) return response.data;
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const saveAppUser = createAsyncThunk(
  'appUser/save',
  async (userData, { dispatch, rejectWithValue }) => {
    try {
      const response = await appUserService.save(userData);
      if (response.status) {
        dispatch(fetchAppUsers()); // Refresh list after save
        return response.data;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAppUser = createAsyncThunk(
  'appUser/delete',
  async (userId, { dispatch, rejectWithValue }) => {
    try {
      const response = await appUserService.delete(userId);
      if (response.status) {
        dispatch(fetchAppUsers()); // Refresh list after delete
        return userId;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const appUserSlice = createSlice({
  name: 'appUser',
  initialState: {
    users: [],
    selectedUser: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAppUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload;
      })
      .addCase(fetchAppUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAppUserById.fulfilled, (state, action) => {
        state.selectedUser = action.payload;
      });
  }
});

export const { setSelectedUser } = appUserSlice.actions;
export default appUserSlice.reducer;
